export const breakpointTablet = '481px';
export const breakpointLargeTablet = '768px';
export const breakpointDesktop = '1200px';
